function ContainerXXL(props) {
    return (
        <div className="container-xxl px-md-5">{props.children}</div>
    );
}

export default ContainerXXL;